import { graphql, useStaticQuery } from "gatsby"

// um von ueberall auf die in gatsby-config.js definierten metadaten zuzugreifen

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          image
          keywords
        }
      }
    }
  `)

  return data.site.siteMetadata
}